<template>
    <div>
        <a-tooltip
            :prefixCls="$prefixClass.tooltip"
            overlayClassName="tooltip-menu-item"
            placement="rightTop"
            :visible = isVisible
        >
            <template slot="title" >
                <div>
                    <p class="tooltip-title m-b-4">{{$t('app.tooltip_sidebar.' + item.key + '.title')}}</p>
                     <template v-if="type == 'PerceivedSpeed'">
                        <p class="m-b-16" v-html="$t('app.tooltip_sidebar.' + item.key + '.content' + (store.app_plan == 'actual' ? '_plan_actual' : ''))"></p>
                    </template>
                    <template v-else>
                        <p class="m-b-16" v-html="$t('app.tooltip_sidebar.' + item.key + '.content')"></p>
                    </template>
                    <div class="text-center">
                        <template v-if="type == 'PerceivedSpeed'">
                            <img src="@/assets/images/tooltip-perceived.svg" alt="perceived">
                        </template>
                        <template v-else>
                            <img src="@/assets/images/tooltip-actual.svg" alt="actual">
                        </template>
                    </div>
                    <div class="tooltip-btn-groups">
                        <template v-if="type == 'PerceivedSpeed'">
                            <a href="https://help.perfectapps.io/en/article/what-is-perceived-speed-1juipzi/?1605670228603" target="_blank" :class="[$prefixClass.link]" :prefixCls="$prefixClass.link" >Learn more</a>
                            <a-button type="default"  @click="closeTooltip">Got it</a-button>
                        </template>
                        <template v-else>
                            <a-button type="default" @click="closeTooltip">Next <i class="m-l-3 far fa-chevron-right"></i></a-button>
                        </template>
                    </div>
                </div>
            </template>
            <span :class="$prefixClass.menu + '-text'">{{item.title}}</span>
        </a-tooltip>
    </div>
</template>
<script>
import { mapGetters } from "vuex"
import { types as typesAuth } from "@/modules/auth/constant"

export default {
    name: 'TooltipMenu',
    props: {
        value: {
            type: Boolean,
            default: true,
            required: true
        },
        type: {
            type: String,
            default: 'PerceivedSpeed'
        },
        item: {
            type: Object,
            required: true
        }
    },
    created() {

    },
    computed: {
        isVisible: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        ...mapGetters({
            store: typesAuth.getters.GET_STORE
        })
    },
    methods: {
        closeTooltip() {
            this.isVisible = false;
            this.$emit("close-tooltip")
        },
    }
}
</script>
<style lang="scss">
.tooltip-menu-item {
    width: 425px;
    max-width: 425px !important;
    .#{$tooltip}-content {
        border-radius: 4px;
    }
    .#{$tooltip}-arrow {
        &::before {
            background: #5062e9;
        }
    }
    .#{$tooltip}-inner {
        background: #5062e9;
        color: #FFF;
        padding: 16px 16px 24px;
        font-size: 1rem;
        .tooltip-title {
            font-size: 1.125rem;
            font-weight: 600;
        }
        .tooltip-btn-groups {
            margin-top: 16px;
            text-align: right;
            .#{$link} {
                color: #FFF;
                font-weight: 600;
                font-size: 1rem;
                margin-right: 8px;
            }
        }
    }
}
</style>
